import { render, staticRenderFns } from "./lookup-confirmation.vue?vue&type=template&id=33a874f1&scoped=true"
import script from "./lookup-confirmation.vue?vue&type=script&lang=ts"
export * from "./lookup-confirmation.vue?vue&type=script&lang=ts"
import style0 from "./lookup-confirmation.vue?vue&type=style&index=0&id=33a874f1&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a874f1",
  null
  
)

export default component.exports